import React from "react";

const NotFound = () => {
  return (
    <div>
      <h3>No results found</h3>
      <p>Your search did not return any results. Please try again.</p>
    </div>
  );
};

export default NotFound;
